import * as LogisticTasksActions from './logisticTasks';

const Actions = {
  ...LogisticTasksActions,
};

export default Actions;
